import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { API } from "@/App";
import { BizouLogo } from "@/components/BizouLogo";

export default function AuthCallback({ setUser }) {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.warn("[AUTH] No session_id found in hash, redirecting to /");
        navigate("/", { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];
      console.log("[AUTH] Processing OAuth callback, session_id:", sessionId.substring(0, 8) + "...");

      try {
        const response = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });

        console.log("[AUTH] Session exchange response:", response.status);

        if (!response.ok) throw new Error("Failed to exchange session");

        const data = await response.json();
        console.log("[AUTH] User authenticated:", data.user?.email);
        if (setUser && data.user) setUser(data.user);

        // Determine redirect destination:
        // 1. sessionStorage (set by ProtectedRoute when an unauthenticated user
        //    tried to access a protected page like /invoices)
        // 2. The current path if it's not root
        // 3. Fallback to /dashboard
        let redirectTo = "/dashboard";
        try {
          const stored = sessionStorage.getItem("bizou_redirect_after_login");
          if (stored && stored.startsWith("/") && !stored.startsWith("//")) {
            redirectTo = stored;
            sessionStorage.removeItem("bizou_redirect_after_login");
          } else {
            const currentPath = location.pathname;
            if (currentPath && currentPath !== "/") redirectTo = currentPath;
          }
        } catch (e) {
          const currentPath = location.pathname;
          if (currentPath && currentPath !== "/") redirectTo = currentPath;
        }
        console.log("[AUTH] Redirecting to:", redirectTo);
        navigate(redirectTo, { replace: true });
      } catch (error) {
        console.error("[AUTH] Callback error:", error);
        navigate("/", { replace: true });
      }
    };

    processAuth();
  }, [location.hash, location.pathname, navigate, setUser]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <BizouLogo size="lg" />
        </div>
        <div className="spinner mx-auto mb-4"></div>
        <p className="text-[#78716C]">Connexion en cours...</p>
      </div>
    </div>
  );
}
